const searchContextOptions = [
  { label: 'searchOption.searchContext.metadata', value: 0 },
  { label: 'searchOption.searchContext.content', value: 1 },
  { label: 'searchOption.searchContext.metadataAndContent', value: 2 }
]

export default {
  searchContextOptions
}
